import CustomerView from "../../Components/Customers/CustomerView";

export default function ViewCustomer() {
    return (
        <CustomerView />
    )
}